var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Print",
    clipPath: "url(#clip0_25842_59757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.3326C8.22386 16.3326 8 16.5677 8 16.8576C8 17.1476 8.22386 17.3826 8.5 17.3826H11.5C11.7761 17.3826 12 17.1476 12 16.8576C12 16.5677 11.7761 16.3326 11.5 16.3326H8.5Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.2326C8 13.9427 8.22386 13.7076 8.5 13.7076H11.5C11.7761 13.7076 12 13.9427 12 14.2326C12 14.5226 11.7761 14.7576 11.5 14.7576H8.5C8.22386 14.7576 8 14.5226 8 14.2326Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.52012V2.42012C15 1.84022 14.5523 1.37012 14 1.37012H6C5.44772 1.37012 5 1.84022 5 2.42012V4.52012H4C2.34315 4.52012 1 5.93042 1 7.67012V13.9701C1 15.7098 2.34315 17.1201 4 17.1201H5V19.2201C5 19.8 5.44772 20.2701 6 20.2701H14C14.5523 20.2701 15 19.8 15 19.2201V17.1201H16C17.6569 17.1201 19 15.7098 19 13.9701V7.67012C19 5.93042 17.6569 4.52012 16 4.52012H15ZM6.5 2.94512V4.52012H13.5V2.94512H6.5ZM13.5 12.3951H6.5V18.6951H13.5V12.3951ZM5 7.67012C4.72386 7.67012 4.5 7.90517 4.5 8.19512C4.5 8.48507 4.72386 8.72012 5 8.72012H6C6.27614 8.72012 6.5 8.48507 6.5 8.19512C6.5 7.90517 6.27614 7.67012 6 7.67012H5Z",
    fill: "#737373"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25842_59757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.320312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintDark);
export default __webpack_public_path__ + "static/media/print-dark.b6d0ce1eec2e5352e979d579b8bf111e.svg";
export { ForwardRef as ReactComponent };